<div id="openModal" class="card pb-0 mb-0">
    <div class="modal-header bg-soft-info p-3">

        <div class="">
            <h5 class="card-title mb-0">{{entityName}}</h5>
        </div>
        <div *ngIf="entityFileUpload.entityId" class="justify-content-end d-flex  flex-grow-1" style="height: 19.195px;">
            <button type="button" data-bs-dismiss="modal" class="btn" aria-label="Close" id="close-modal" style="
                box-sizing: content-box; 
                color: var(--vz-body-color);
                border: 0;
                font-size: 1rem;
                transform: rotate(-270deg) !important;
                border-radius: 0.25rem;
                opacity: 0.5;" (click)="minimizeButton()">
                <i class="ri-picture-in-picture-2-line align-bottom"></i>
            </button>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
            (click)="dismiss()">
        </button>

    </div>
    <div class="card-body">
        <div *ngIf="spinnerIsShown"
            style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
            <div class="spinner-border text-primary avatar-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div *ngIf="canAddToKnowledgeBase" class="col-12 col-md-8 mb-4">
            <label for="job-title-Input" class="form-label">Tags</label>
            <div class="form-control p-0" 
                (click)="accessTypeListController()">
                <div class="d-flex align-items-center form-control " 
                    style="padding: 0%; border-width: 0px; ">
                    <ng-select style="flex-grow: 1; " [multiple]="true"  [selectOnTab]="true"
                        placeholder="Document Tags" [clearSearchOnAdd]="true" [items]="permittedTagList"
                        [isOpen]="isPermittedTagListOpen" [(ngModel)]="tags" [addTag]="addCustomTag" 
                        (focusout)="onBlurEvent($event)"
                        [typeahead]="searchTerm$">
                        <ng-template ng-tag-tmp let-item="item" let-clear="clear">
                            <span class="ng-value-label ">
                                <span style="font-size: 80% !important; ">
                                    Add Custom Tag:
                                </span>
                                <span >
                                    "{{searchTerm}}"
                                </span>
                               
                            </span>
                        </ng-template>
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{item}}
                        </ng-template>
                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                            <div class="d-md-flex">
                                <span class="ng-value-icon left" (click)="clear(item)">×</span>
                                <span class="ng-value-label text-white">
                                    {{item}}
                                </span>
                            </div>
                        </ng-template>
                     
                    </ng-select>
                </div>
            </div>
        </div>
        <dropzone class="dropzone_sec" [message]="'Click or drag groups of files to upload them to your MyFile'" 
            (error)="uploadError($event)" (success)="uploadSuccess($event)" (queueComplete)="complete($event)"
            (sending)="sending($event)" (removedFile)="onRemove($event)" style="max-height: 32rem; overflow: scroll;">
        </dropzone>
        <br />
        <div class="hstack gap-2 justify-content-end">
            <button type="button" class="btn btn-ghost-success" style=" background-color: rgba(19, 197, 107, 0.1); "
                i18n="@@Common_text_Close" (click)="dismiss()"><i class="ri-close-line align-bottom"></i> Close</button>
            <button *ngIf="entityFileUpload.entityId" [disabled]="submitDisabled" type="submit" class="btn btn-primary"
                i18n="@@" (click)="processEntityFiles()">Add</button>
            <button *ngIf="!entityFileUpload.entityId" [disabled]="submitDisabled" type="submit" class="btn btn-primary"
                i18n="@@" (click)="returnFilestoAddList()">Add</button>
        </div>
    </div>
</div>